// If you're here from the future, CookieStore makes this much easier
// https://developer.mozilla.org/en-US/docs/Web/API/CookieStore

interface RemoveCookiesProps {
  regex: RegExp;
  path?: string;
  domain?: string;
}

export function removeCookies({ regex, path, domain }: RemoveCookiesProps) {
  if (typeof document === 'undefined') return;
  if (!document.cookie) return;

  Object.keys(cookieKeys()).forEach((key) => {
    if (regex.test(key)) {
      let cookieString = key + '=; Max-Age=0';
      if (path) cookieString += `; path=${path}`;
      if (domain) cookieString += `; domain=${domain}`;

      document.cookie = cookieString;
    }
  });
}

function cookieKeys() {
  if (typeof document === 'undefined') return {};
  if (!document.cookie) return {};

  const cookies = document.cookie.split('; ');
  const jar: Record<string, string> = {};

  for (let i = 0; i < cookies.length; i++) {
    const parts = cookies[i].split('=');
    const [key, value] = parts;

    jar[decodeURIComponent(key)] = decodeURIComponent(value);
  }

  return jar;
}
